/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Specialists_NoneInputs */

const en_portal_specialists_none = /** @type {(inputs: Portal_Specialists_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody in this category yet.`)
};

const pl_portal_specialists_none = /** @type {(inputs: Portal_Specialists_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W tej kategorii nikogo jeszcze nie ma.`)
};

/**
* | output |
* | --- |
* | "Nobody in this category yet." |
*
* @param {Portal_Specialists_NoneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_specialists_none = /** @type {((inputs?: Portal_Specialists_NoneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Specialists_NoneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_specialists_none(inputs)
	return en_portal_specialists_none(inputs)
});